var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 486,
    viewBox: "0 0 427 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2206_7459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.987 1.18842C529.492 -0.413393 526.913 -0.413393 525.366 1.18842L235.553 291.53C234.057 293.029 231.582 293.029 230.086 291.53L99.0282 160.285C98.2546 159.51 97.0683 159.51 96.2946 160.285L0.567304 256.187C-0.206354 256.962 -0.206354 258.15 0.567304 258.925L230.086 488.863C231.582 490.362 234.057 490.362 235.553 488.863L528.254 195.628C581.688 142.096 582.616 55.8568 531.039 1.18842H530.987Z",
    fill: "#CBD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.82 211.439C278.937 211.439 316.323 173.985 316.323 127.783C316.323 81.5815 278.937 44.1274 232.82 44.1274C186.702 44.1274 149.316 81.5815 149.316 127.783C149.316 173.985 186.702 211.439 232.82 211.439Z",
    fill: "#CBD6D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2206_7459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 569,
    height: 490,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.885b44a7cb64e96ad37fcdcb6a02d74c.svg";
export { ForwardRef as ReactComponent };